import axios from 'axios';

class SupportClient {
    static getRegistrationsByState(state) {
        return axios.get(`/api/registrations/state/${state}`);
    }

    static loadRegistrationById(id) {
        return axios.get(`/api/registrations/${id}`);
    }

    static setRegistrationState(id, state, sendMail) {
        return axios.put(`/api/registrations/${id}/state`, { state: state, sendMail: sendMail });
    }

    static markDone(id, comment) {
        return axios.put(`/api/registrations/${id}/state`, { state: 'done', comment: comment });
    }

    static addComment(id, comment) {
        return axios.post(`/api/registrations/${id}/comments`, { comment: comment });
    }

    static loadUsageByInstance(instance) {
        return axios.get(`/api/usage/${instance}`);
    }
}

export default SupportClient;
